import React from 'react'

import { Box, Fade, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { useResponsiveBreakpoint } from 'common/use-responsive-breakpoint'
import ScrollWrapper from 'components/ScrollWrapper'

import { useAwesomeBarContext } from '../AwesomeBarContext'
import Content from './Content'

export const getTop = (isXs: boolean) => (isXs ? '120px' : '60px')
export const preventDefault = (e: React.SyntheticEvent) => e.preventDefault()

const useStyles = makeStyles({
  root: {
    '&:focus-within': {
      display: 'block !important',
      opacity: '1 !important',
      visibility: 'visible !important',
    },
  },
})

/**
 * This is the dropdown that appears when the user clicks on the search bar.
 * It displays "focusDropdownSections" and disappears when the user starts typing
 */
const FocusDropdown = () => {
  const { showFocusDropdown, focusDropdownSections } = useAwesomeBarContext()
  const classes = useStyles()
  const isXs = useResponsiveBreakpoint('xs')
  const hasSections = focusDropdownSections.length > 0
  return !hasSections ? null : (
    <Fade
      in={showFocusDropdown}
      // @ts-expect-error unsupported prop?
      className={classes.root}
    >
      <Box
        id="main-nav-empty-search-dropdown"
        maxWidth="640px"
        width={isXs ? '95%' : '70%'}
        position="absolute"
        zIndex={12}
      >
        <Paper
          elevation={8}
          onMouseDownCapture={preventDefault}
        >
          <ScrollWrapper
            maxHeight="50vh"
            stopPropagation
          >
            <Box
              pb={2}
              width="100%"
              position="relative"
              zIndex={0}
            >
              <Content open={showFocusDropdown} />
            </Box>
          </ScrollWrapper>
        </Paper>
      </Box>
    </Fade>
  )
}

export { default as FocusDropdownTitle } from './FocusDropdownTitle'

export default FocusDropdown
